import { MouseEvent, useState } from "react"
import { KTIcon } from "../../../../../../../_metronic/helpers"
import { Table } from "../../../../../../../components/Table"
import { TableHead } from "../../../../../../../components/Table/TableHead"
import { TableBody } from "../../../../../../../components/Table/TableBody"
import MessageTemplateItemRow from "./MessageTemplateItemRow"
import { convertUTCtoMSK } from "../../../../../../../utils"
import { IMessageTemplate } from "../../core/response.types"

interface Props {
  template: IMessageTemplate
}

export default ({ template }: Props) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false)

    const toggleOpen = (e: MouseEvent<HTMLTableRowElement>) => {
        if ((e.target as HTMLElement)?.closest('a')) return
        setIsExpanded((prev) => !prev)
    }

    return (<>
        <tr className={'cursor-pointer'} onClick={toggleOpen}>
            <td className='text-center align-middle'>
                <KTIcon
                    iconName={isExpanded ? 'arrow-down' : 'arrow-right'}
                    className={`fs-2 text-primary`}
                />
            </td>
            <td>{template.requisiteType}</td>
            <td>{template.channel}</td>
            <td>{template.operation}</td>
            <td>{template.matchCount}</td>
            <td>{template.lastMatchAt ? convertUTCtoMSK(template.lastMatchAt) : '-'}</td>
        </tr>

        {isExpanded && template.matchers?.length ? (
            <tr>
                <td colSpan={6} className='p-0'>
                    <div className='m-4 border bg-background-light'>
                        <Table>
                            <TableHead>
                            <tr>
                                <th className='min-w-120px ps-8'><small>Регулярное выражение</small></th>
                                <th className='min-w-100px'><small>Маска поиска</small></th>
                                <th className='min-w-150px'><small>Дата добавления</small></th>
                                <th className='min-w-100px'><small>Всего сообщений</small></th>
                                <th className='min-w-150px'><small>Дата последнего смс</small></th>
                            </tr>
                            </TableHead>
                            <TableBody>
                                {template.matchers.map((mt, idx) => (
                                    <MessageTemplateItemRow
                                        key={mt.id || idx}
                                        matcher={mt}
                                    />
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </td>
            </tr>
        ) : null}
    </>)
}